module.exports = __webpack_public_path__ + "static/media/belov.11eec0d0.jpg";